export { GridImage, type GridImageProps } from './GridImage';
